import React, { useState,useEffect } from 'react';
import {Form,Button,Table,Input} from 'antd';
import ProductListModal from '../components/ProductList';
import {saveQualityStandard,getQualityStandardInfo} from '../util/api';
import { Space } from 'antd';
import '../qualityGradient/index.less';
import { useHistory,useParams } from 'react-router-dom';
import { message } from 'antd';
const layout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 10 },
};

const QualityStandardDetail = ()=>{
  const history = useHistory();
  const [open,setOpen] = useState(false);
  const [form] = Form.useForm();
  const params = useParams();
  const [count,setCount] = useState(0);
  const [standardList,setStandardList] = useState([]);
  const [productList,setproductList] = useState([]);
  const handleValidation = async () => {
    try {
      const result = await form.validateFields();
      const {name,purchaser,} = result || {};
      const filledValues = []; // 用于存储已填写的数据
      const duplicateValues = []; // 用于存储重复的数据
      standardList.forEach(item => {
        const fieldValue = form.getFieldValue(`project[${item.key}]`);
        if (fieldValue) {
          if (filledValues.includes(fieldValue)) {
            duplicateValues.push(fieldValue);
          } else {
            filledValues.push(fieldValue);
          }
        }
      });
      if (duplicateValues.length > 0) {
        return message.error('质检项目重复,请重新维护');
      }
      const standard =  standardList.map(item=>{
        return {
          project:form.getFieldValue(`project[${item.key}]`),
          qualified:form.getFieldValue(`qualified[${item.key}]`),
          unqualified:form.getFieldValue(`unqualified[${item.key}]`),
        };
      });
      const res = await saveQualityStandard({
        name,
        id:params?.id,
        purchaser,
        products:productList,
        standard
      });
      const {msg,code} = res.data || {};
      console.log(res);
      if(code === 0){
        message.success(msg);
        history.push('/basic/user/qualityStandard');
      }else{
        message.error(msg);
      }
    } catch (error) {
      // 处理错误
    }
  };

  const onFinish = (values) => {

    handleValidation();
  };
  useEffect(()=>{
      if(params?.id){
        getQualityStandardInfo({id:params?.id}).then(result=>{
          const {data,code,msg} = result.data || {};
          if(code === 0 ){
            console.log(data);
            const {name,purchaser,products=[],standard=[]} = data || {};

            setproductList(products);
            let obj = {},newCount = 0;
            standard.forEach((item,i)=>{
               newCount ++;
              obj[`project[${newCount}]`] = item.project;
              obj[`qualified[${newCount}]`] = item.qualified;
              obj[`unqualified[${newCount}]`] = item.unqualified;
            });
            let standardList = standard.map((_,i)=>{
              return {
                key:i + 1,
              };
            });
            setCount(newCount);
            setStandardList(standardList);
            form.setFieldsValue({
              name,
              purchaser,
              ...obj
            });
          }else{
            message.error(msg);
          }
        });
      }else{
       add();
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);
  const handleOpenProduct = ()=>{
    setOpen(true);
  };
  const standardColumns = [
    {
      title:'*质检项目',
      dataIndex:'standard',
      align:'center',
      render:(_,record)=>{
          return (
            <Form.Item
            wrapperCol={{span:16,offset:4}}
            name={`project[${record.key}]`}
            rules={[{
              required:true,
              message:'请输入质检项目'
            }]}
            >
                <Input />
            </Form.Item>
          );
      }
    },
    {
      title:'*合格描述',
      dataIndex:'describe',
      align:'center',
      render:(_,record)=>{
        return (
          <Form.Item
          wrapperCol={{span:16,offset:4}}
          name={`qualified[${record.key}]`}
          rules={[{
            required:true,
            message:'请输入合格描述'
          }]}
          >
              <Input />
          </Form.Item>
        );
      }
    },
    {
      title:'*不合格描述',
      dataIndex:'unqualified-describe',
      align:'center',
      render:(_,record)=>{
        return (
          <Form.Item
          wrapperCol={{span:16,offset:4}}
          name={`unqualified[${record.key}]`}
          rules={[{
            required:true,
            message:'请输入不合格描述'
          }]}
          >
              <Input />
          </Form.Item>
        );
      }
    },
    {
      title:'操作',
      dataIndex:'op',
      align:'center',
      render:(_,record,index)=>{
        return <span style={{cursor:'pointer'}} disabled={standardList.length === 1} onClick={(e)=>handleProductDelete(e,record)}>删除</span>;
      }
    },
  ];
  const handleProductDelete = (e,record) => {
    e.preventDefault(); // 阻止默认行为
    e.stopPropagation(); // 阻止事件冒泡
    if(standardList.length === 1){
      return ;
    };
    const data = standardList.filter(item=>item.key !== record.key);
    setStandardList(data);
  };
  const add = () => {
   const newCount = count + 1;
    setCount(newCount);
    setStandardList([...standardList,{key:newCount}]);
  };
  const columns = [
    { title: '商品分类', key: 'category_list', dataIndex: 'category_list', align: 'center', },
    { title: 'SKU编码', key: 'sku_no', dataIndex: 'sku_no', align: 'center', },
    { title: '商品名称', key: 'sale_name', dataIndex: 'sale_name', align: 'center', },
    { title: 'ITEM单位', key: 'item_unit', dataIndex: 'item_unit', align: 'center', },
    {
      title:'操作',
      dataIndex:'op',
      align:'center',
      render: (_, record) => {
        return (
          <>
            <a
              className="custom-options-title"
              onClick={() => deleteItem(record)}
            >
              删除
            </a>
          </>
        );
      },
    },
  ];
  const deleteItem = (record) => {
    let newArr = productList.filter((item) => {
      return item.sku_no !== record.sku_no;
    });
    setproductList(newArr);
  };
  const handleCancel = () => setOpen(false);
  const handleProduct = (data) => {
    const updatedProductList = [...productList];
    data.forEach((item) => {
      if (!updatedProductList.some((product) => product.sku_no === item.sku_no)) {
        updatedProductList.push(item);
      }
    });

    setproductList(updatedProductList);
    setOpen(false);
  };
  return (
    <>
    
      <div style={{display:'flex',fontSize:'20px',fontWeight:'500',margin:'10px 0',}}>
        <span style={{textDecoration:'underline',cursor:'pointer',color:'#1890FF',}} onClick={()=>history.go(-1)}>质检标准</span><span>/详情页</span>
      </div>
      <Form {...layout} form={form} name="quality"  onFinish={onFinish}>
            <Form.Item
              label="质检标准名称"
              name='name'
              rules={[{ required: true, message: '请输入质检标准名称' }]}
              >
              <Input />
            </Form.Item>
            <Form.Item label='商品明细'>
              <Button type='primary' onClick={handleOpenProduct}>添加商品</Button>
            </Form.Item>
            <Table
            columns={columns}
            className='quality-table-cell'
            dataSource={productList}
            rowKey={'sku_no'}
            style={{margin:'10px 10px'}}/>
            <Form.Item
            label='采购员'
            name='purchaser'
            rules={[
              { required: true, message: '请输入采购员名称' },
            ]}
            >
             <Input/>
            </Form.Item>
            <Form.Item  label='质检项目明细'>
              <Button type='primary' onClick={add}>添加项目</Button>
            </Form.Item>
              <Table
                columns={standardColumns}
                dataSource={standardList}
                pagination={false}
                scroll={{y:400}}
              />
            <Form.Item />
            <Form.Item wrapperCol={{span:12,offset:10}}>
              <Space >
                  <Button type='primary' htmlType="submit">确定</Button>
                  <Button onClick={()=>history.go(-1)}>取消</Button>
              </Space>
            </Form.Item>
      </Form>
      {
          open &&<ProductListModal type={2} handleProduct={handleProduct} handleCancel={handleCancel} />
        }
    </>
  );
};

export default QualityStandardDetail;